import React, { useState } from 'react';
import { AssetProvider } from './AssetsContext';
import { AudioProvider } from './AudioContext';
import UserForm from './UserForm/UserForm';
// import Factory from './Story/Factory';
// import Scene0 from './Story/Scene0';
// import Scene1 from './Story/Scene1';
// import Scene2 from './Story/Scene2';
// import Scene3 from './Story/Scene3';
// import Scene4 from './Story/Scene4';
// import Scene5 from './Story/Scene5/Scene5';
// import Scene6 from './Story/Scene6';
// import Scene7 from './Story/Scene7';
// import Scene8 from './Story/Scene8';

const Onboarding = ({ handleOnboarding }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [skip, setSkip] = useState(false);

  function handleSkip() {
    if (skip) return;
    setSkip(true);
    setCurrentStep(7);
  }

  function onNext() {
    if (currentStep >= STEPS.length - 1) return;
    setCurrentStep(currentStep + 1);
  }

  const STEPS = [
    // <Scene0 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Scene1 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Scene2 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Scene3 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Scene4 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Factory onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    // <Scene5 onNext={onNext} handleSkip={handleSkip} skip={skip} />,
    <UserForm onNext={handleOnboarding} skip={skip} handleOnboarding={handleOnboarding} />,
    // <Scene6 onNext={onNext} />,
    // <Scene7 onNext={onNext} />,
    // <Scene8 onNext={handleOnboarding} />,
  ];
  return (
    <AssetProvider>
      <AudioProvider>{STEPS[currentStep]}</AudioProvider>
    </AssetProvider>
  );
};

export default Onboarding;
